import { types } from './types';

export const setCurrentDialog = (dialogToSet) => {
    return {
        type: types.SET_CURRENT_DIALOG,
        payload: dialogToSet
    }
};


// WEBPACK FOOTER //
// ./src/js/actions/dialog-actions.js